<div *ngFor="let provincia of province" style="display: flex; justify-content: space-between;">
  <label class="label" for="sleep-1">{{provincia.prLabel}}</label>
  <input type="checkbox" id={{provincia.prValue}} name={{provincia.prValue}} (change)="onChange(provincia.prValue, $event)" [(ngModel)]="provincia.selected">
</div>
